import i18n from "../../i18n/i18n"

export enum ReceiptType {
    NotSet = 0,
    CitizenSubmitApplicationForTax = 1,
    EducationalInstitutionSubmitApplicationForTax = 2,
    PaymentReceipt = 3,
    TemporaryCertificateAndPaymentRequest = 4,
    CitizenResubmitApplicationForTax = 5,
    AdministrativeCaseworkerReordersReplacementApplicationForTax = 6,
    TemporaryCertificateReorderedWithoutPaymentRequest = 7,
    TemporaryCertificateReorderedWithPaymentRequest = 8,
    EducationalInstitutionResubmitApplicationForTax = 9,
    EducationalInstitutionSubmitApplicationForCub = 10,
    EducationalInstitutionResubmitApplicationForCub = 11,
    CitizenSubmitApplicationForCub = 12,
    BulkOnlinePaymentRequestForAllCertificateTypes = 13,
    BulkPaymentReceiptForAllCertificateTypes = 14,
    TemporaryCertificate = 15,
    EducationalInstitutionSubmitAndApproveApplicationGeneric = 16,
    EducationalInstitutionResubmitApplicationForVub = 17,
    CitizenSubmitAndApproveApplicationGeneric = 18,
    PaymentRequest = 19,
    ReorderedTemporaryCertificate = 20,
    CommentUpdate = 21,
    ApplicationRejected = 22,
    EducationalInstituionFailedCitizen = 23,
    ApplicationCancelled = 24,
    AdministrativeCaseworkerReordersReplacementApplicationGeneric = 25,
    CertificateCancelled = 26,
    AdministrativeCaseworkerRevokesCertificate = 27,
    AdministrativeCaseworkerReactivatesRevokedCertificate = 28,
    TemporaryCertificateAndPaymentRequestForAdr = 30,
    TemporaryCertificateReorderedWithoutPaymentRequestForAdr = 31,
    TemporaryCertificateReorderedWithPaymentRequestForAdr = 32,
    TemporaryCertificateForAdr = 33,
    ReorderedTemporaryCertificateForAdr = 34
}

// tslint:disable-next-line:no-namespace
export namespace ReceiptType {
	export function displayName(type: ReceiptType) {
		const values: { [index: number]: string } = {
			1: "ENUM_RECEIPTTYPE_CITIZENSUBMITAPPLICATIONFORTAX",
			2: "ENUM_RECEIPTTYPE_EDUCATIONALINSTITUTIONSUBMITAPPLICATIONFORTAX",
			3: "ENUM_RECEIPTTYPE_PAYMENTRECEIPT",
			4: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATEANDPAYMENTREQUEST",
			5: "ENUM_RECEIPTTYPE_CITIZENRESUBMITAPPLICATIONFORTAX",
			6: "ENUM_RECEIPTTYPE_ADMINISTRATIVECASEWORKERREORDERSREPLACEMENTAPPLICATIONFORTAX",
			7: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATEREORDEREDWITHOUTPAYMENTREQUEST",
			8: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATEREORDEREDWITHPAYMENTREQUEST",
			9: "ENUM_RECEIPTTYPE_EDUCATIONALINSTITUTIONRESUBMITAPPLICATIONFORTAX",
			10: "ENUM_RECEIPTTYPE_EDUCATIONALINSTITUTIONSUBMITAPPLICATIONFORCUB",
			11: "ENUM_RECEIPTTYPE_EDUCATIONALINSTITUTIONRESUBMITAPPLICATIONFORCUB",
			12: "ENUM_RECEIPTTYPE_CITIZENSUBMITAPPLICATIONFORCUB",
			13: "ENUM_RECEIPTTYPE_BULKONLINEPAYMENTREQUESTFORALLCERTIFICATETYPES",
			14: "ENUM_RECEIPTTYPE_BULKPAYMENTRECEIPTFORALLCERTIFICATETYPES",
			15: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATE",
			16: "ENUM_RECEIPTTYPE_EDUCATIONALINSTITUTIONSUBMITANDAPPROVEAPPLICATIONGENERIC",
			17: "ENUM_RECEIPTTYPE_EDUCATIONALINSTITUTIONRESUBMITAPPLICATIONFORVUB",
			18: "ENUM_RECEIPTTYPE_CITIZENSUBMITANDAPPROVEAPPLICATIONGENERIC",
			19: "ENUM_RECEIPTTYPE_PAYMENTREQUEST",
			20: "ENUM_RECEIPTTYPE_REORDEREDTEMPORARYCERTIFICATE",
			21: "ENUM_RECEIPTTYPE_COMMENTUPDATE",
			22: "ENUM_RECEIPTTYPE_APPLICATIONREJECTED",
			23: "ENUM_RECEIPTTYPE_EDUCATIONALINSTITUIONFAILEDCITIZEN",
			24: "ENUM_RECEIPTTYPE_APPLICATIONCANCELLED",
			25: "ENUM_RECEIPTTYPE_ADMINISTRATIVECASEWORKERREORDERSREPLACEMENTAPPLICATIONGENERIC",
			26: "ENUM_RECEIPTTYPE_CERTIFICATECANCELLED",
			27: "ENUM_RECEIPTTYPE_ADMINISTRATIVECASEWORKERREVOKESCERTIFICATE",
			28: "ENUM_RECEIPTTYPE_ADMINISTRATIVECASEWORKERREACTIVATESREVOKEDCERTIFICATE",
			30: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATEANDPAYMENTREQUESTFORADR",
			31: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATEREORDEREDWITHOUTPAYMENTREQUESTFORADR",
			32: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATEREORDEREDWITHPAYMENTREQUESTFORADR",
			33: "ENUM_RECEIPTTYPE_TEMPORARYCERTIFICATEFORADR",
			34: "ENUM_RECEIPTTYPE_REORDEREDTEMPORARYCERTIFICATEFORADR"
		}

		if (values.hasOwnProperty(type)) {
			return i18n.t(values[type])
		} else {
			return i18n.t(ReceiptType[type])
		}
	}
}
